import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BoxHistory from '../../../../components/assessmentTimeline/BoxHistory';
import SendNotificationButton from '../../../../components/button/SendNotificationButton';
import { AssessmentConstants } from '../../../../shared/Constants';
import { Loading } from '../../../../components/Loading';

class SurveyTimelineBox extends Component {
  render() {
    const {
      surveyData, sendRemindingEmail, sendInviteEmail, isEmailSending,
    } = this.props;
    if (!surveyData) {
      return <Loading />;
    }
    return (
      <div className="mt30 panel panel-default panel-padded">
        <div className="panel-body">
          <div className="timeline">
            {surveyData.submittedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.SUBMITTED} date={surveyData.submittedOn} />
                </div>
              </div>
            ) : null}

            {surveyData.status === AssessmentConstants.ASMT_STATUS.EXPIRED ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.EXPIRED} date={surveyData.expiredOn} />
                </div>
              </div>
            ) : null}

            {surveyData.declinedOn && surveyData.status === AssessmentConstants.ASMT_STATUS.DECLINED ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.DECLINED} date={surveyData.declinedOn} />
                </div>
              </div>
            ) : null}

            {surveyData.startedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.STARTED} date={surveyData.startedOn} />
                </div>

                {surveyData.status === AssessmentConstants.ASMT_STATUS.STARTED ? (
                  <SendNotificationButton
                    assessment={surveyData}
                    isDisabled={isEmailSending}
                    actionMethod={sendRemindingEmail}
                  />
                ) : null}
              </div>
            ) : null}

            {surveyData.invitedOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.INVITED} date={surveyData.invitedOn} />
                </div>

                {surveyData.status === AssessmentConstants.ASMT_STATUS.INVITED ? (
                  <SendNotificationButton
                    assessment={surveyData}
                    isDisabled={isEmailSending}
                    actionMethod={sendRemindingEmail}
                  />
                ) : null}
              </div>
            ) : null}

            {surveyData.createdOn ? (
              <div className="timeline-item">
                <div className="timeline-header">
                  <BoxHistory status={AssessmentConstants.ASMT_STATUS.NEW} date={surveyData.createdOn} />
                </div>
                {surveyData.status === AssessmentConstants.ASMT_STATUS.NEW ? (
                  <SendNotificationButton
                    assessment={surveyData}
                    isDisabled={isEmailSending}
                    actionMethod={sendInviteEmail}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

SurveyTimelineBox.propTypes = {
  surveyData: PropTypes.objectOf(PropTypes.any).isRequired,
  sendRemindingEmail: PropTypes.func.isRequired,
  sendInviteEmail: PropTypes.func.isRequired,
  isEmailSending: PropTypes.bool.isRequired,
};

export default SurveyTimelineBox;
